var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSignature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83,
    height: 95.188,
    viewBox: "0 0 83 95.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#8573e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#5e4edd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#fcc332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#f99e32"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22838",
    "data-name": "\\uADF8\\uB8F9 22838",
    transform: "translate(-1871.105 -1079.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4",
    "data-name": "\\uADF8\\uB8F9 4",
    transform: "translate(1871.105 1154.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3",
    "data-name": "\\uADF8\\uB8F9 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M1880.181,1532.363a3.328,3.328,0,0,1-3.111-2.116l-5.823-14.738a1.978,1.978,0,0,1,1.839-2.7h.369a1.986,1.986,0,0,1,1.855,1.291l5.067,13.694,5.043-13.691a1.986,1.986,0,0,1,1.856-1.294,1.978,1.978,0,0,1,1.84,2.7l-5.823,14.738A3.327,3.327,0,0,1,1880.181,1532.363Z",
    transform: "translate(-1871.105 -1512.291)",
    fill: "#5c626d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2",
    "data-name": "\\uD328\\uC2A4 2",
    d: "M1997.67,1530.371c-6.126,0-10.573-4.323-10.573-10.28s4.447-10.28,10.573-10.28,10.574,4.324,10.574,10.28S2003.8,1530.371,1997.67,1530.371Zm0-16.9a6.625,6.625,0,1,0,6.477,6.623A6.336,6.336,0,0,0,1997.67,1513.468Z",
    transform: "translate(-1966.953 -1509.811)",
    fill: "#5c626d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3",
    "data-name": "\\uD328\\uC2A4 3",
    d: "M2133.949,1532.363a3.319,3.319,0,0,1-3.315-3.315v-12.929a3.319,3.319,0,0,1,3.315-3.315h4.229c6.378,0,10.5,3.844,10.5,9.792,0,5.933-4.122,9.767-10.5,9.767Zm1.305-15.975a.524.524,0,0,0-.523.523v11.344a.524.524,0,0,0,.523.523h3c3.963,0,6.33-2.312,6.33-6.183,0-3.887-2.367-6.208-6.33-6.208Z",
    transform: "translate(-2085.592 -1512.291)",
    fill: "#5c626d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4",
    "data-name": "\\uD328\\uC2A4 4",
    d: "M2260.548,1532.363a1.986,1.986,0,0,1-1.855-1.291l-5.067-13.694-5.043,13.691a1.985,1.985,0,0,1-1.856,1.294,1.978,1.978,0,0,1-1.839-2.7l5.823-14.738a3.345,3.345,0,0,1,6.223,0l5.823,14.738a1.978,1.978,0,0,1-1.839,2.7Z",
    transform: "translate(-2179.898 -1512.291)",
    fill: "#5c626d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7",
    "data-name": "\\uADF8\\uB8F9 7",
    transform: "translate(1878.345 1079.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_5",
    "data-name": "\\uADF8\\uB8F9 5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5",
    "data-name": "\\uD328\\uC2A4 5",
    d: "M1935.923,1129.8l-17.615-6.411a7.522,7.522,0,0,1-4.949-7.068v-30.865a5.641,5.641,0,0,1,7.57-5.3l14.993,5.457Z",
    transform: "translate(-1913.359 -1079.811)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6",
    "data-name": "\\uD328\\uC2A4 6",
    d: "M2045.051,1129.8l17.615-6.411a7.521,7.521,0,0,0,4.949-7.068v-30.865a5.641,5.641,0,0,0-7.57-5.3l-14.993,5.457Z",
    transform: "translate(-2022.487 -1079.811)",
    fill: "#8573e7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_6",
    "data-name": "\\uADF8\\uB8F9 6",
    transform: "translate(23.394 11.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7",
    "data-name": "\\uD328\\uC2A4 7",
    d: "M2067.615,1148.051,2050,1154.462a7.521,7.521,0,0,0-4.948,7.068v30.865a5.641,5.641,0,0,0,7.57,5.3l14.994-5.457Z",
    transform: "translate(-2045.051 -1148.051)",
    fill: "#f99e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8",
    "data-name": "\\uD328\\uC2A4 8",
    d: "M2176.742,1148.051l17.615,6.411a7.521,7.521,0,0,1,4.949,7.068v30.865a5.641,5.641,0,0,1-7.57,5.3l-14.994-5.457Z",
    transform: "translate(-2154.178 -1148.051)",
    fill: "url(#linear-gradient-2)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSignature);
export default __webpack_public_path__ + "static/media/logo-signature.940c38b6.svg";
export { ForwardRef as ReactComponent };